/**
 * USD list prices shown in Studio Billing (and success copy).
 * Stripe checkout follows Product/Price IDs in the Stripe Dashboard
 * (functions env STRIPE_PRICE_* and optional STRIPE_PRICE_*_YEARLY) — keep those in sync.
 */
export const PROFESSIONAL_SUBSCRIPTION_USD_MONTHLY = 99;
export const STUDIO_SUBSCRIPTION_USD_MONTHLY = 199;

/**
 * Annual Professional charge (USD). ~20% off vs 12× monthly — Stripe yearly Price must match.
 */
export const PROFESSIONAL_SUBSCRIPTION_USD_YEARLY = 950;

/**
 * Annual Studio charge for Stripe (10× monthly). Studio billing card is monthly-only in UI; yearly ID must match if offered.
 */
export const STUDIO_SUBSCRIPTION_USD_YEARLY = STUDIO_SUBSCRIPTION_USD_MONTHLY * 10;

/**
 * Whole-number percent saved vs paying 12× list monthly (USD). Same ratio in any display currency.
 */
export function annualPlanSavingsPercent(monthlyUsd, yearlyUsd) {
    const annualAtMonthlyRate = monthlyUsd * 12;
    if (annualAtMonthlyRate <= 0 || yearlyUsd >= annualAtMonthlyRate) return 0;
    return Math.round(((annualAtMonthlyRate - yearlyUsd) / annualAtMonthlyRate) * 100);
}

/**
 * Nearest whole USD/month for display when showing an annual plan as an effective monthly rate (÷ 12).
 */
export function roundedMonthlyEquivalentFromAnnualUsd(yearlyUsd) {
    return Math.round(yearlyUsd / 12);
}
